<template>
  <a class="ident-wrap" :href="link?link:params.url" v-if="count!=0">
    {{ count }}
  </a>
</template>

<script>
import {computed} from "vue";
import {useStore} from 'vuex'
export default {
  name: "NewMessageIdent",
  props: {
    params: {
      type: Object,
      default: () => {
      }
    }
  },
  setup: (props, ctx) => {
    const $store = useStore();
    const count = computed(() => {
      let c = $store.state?.chat?.data?.messages?.length;
      if(c>9) {
        c = 9+'+';
      }
      if(c==''||c==undefined) {
        c = 0;
      }
      return c;
    });
    const link = computed(() => {
      return $store.state?.chat?.data?.lastMessageLink;
    });

    //TODO Временное решение на ajax проверки сообщений в чате, потом нужно на сокеты переделать
    const testMessage = () => {
      $store.dispatch('chat/update',props.params.actions.update);
      setTimeout(()=>{
        testMessage();
      },10000);
    };
    testMessage();
    return {
      count,
      link,
    }
  }
}
</script>

<style scoped>
  .ident-wrap {
    display: inline-block;
    background: var(--c-secondary-200);
    width: 25px;
    height: 25px;
    position: absolute;
    right: 0;
    top: 0;
    border: solid 1px #fff;
    border-radius: 50%;
    text-align: center;
    color: #fff;
    line-height: 21px;
    overflow: hidden;
  }
</style>